/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import { useState, useEffect } from "react";
export const PokemonData = () => {
  const [pokemon, setPokemon] = useState(null);
  useEffect(() => {
    const fetchPokemon = () => {
      fetch("https://pokeapi.co/api/v2/ability/").then(result => result.json()).then(data => setPokemon(data));
    };

    fetchPokemon();
  }, []);

  if (!pokemon) {
    return <h1>Fetching pokemon...</h1>;
  }

  return <Box as="pre" color="brand.text" mdxType="Box">
      {JSON.stringify(pokemon, null, 2)}
    </Box>;
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Flex = makeShortcode("Flex");
const Text = makeShortcode("Text");
const Link = makeShortcode("Link");
const Box = makeShortcode("Box");
const layoutProps = {
  PokemonData
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Flex direction="column" justify="center" p={3} bg="brand.background" mdxType="Flex">
      <Text fontSize="3xl" fontWeight="light" color="brand.text" mt={4} m={[3, 3, null]} align="center" mdxType="Text">
Data fetching direct inside this very MDX file
      </Text>
      <Link my={5} href="https://johno.com/use-effect-for-fetching-data-in-mdx/" isExternal color="brand.text" mdxType="Link">
  Example lifted from John Otanders blog
      </Link>

      <PokemonData mdxType="PokemonData" />
    </Flex>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
